var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed right-0 z-10 m-auto mr-4 flex flex-col justify-between bg-red-500/60 p-1 backdrop-blur-3xl sm:mt-0 md:p-1.5",class:[_vm.classStyles['bg-secondary_color-500'], _vm.styles['dropdown_element']]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }